import Hero from '../components/Hero'
import Map from '../components/Map'
import LogoTicker from '../components/LogoTicker'

export default function Historia() {
  const values = [
    {
      title: 'Empatía',
      description: 'Capacidad de comprender, valorar y ayudar al otro, al estar consciente de sus habilidades.',
      icon: '🫂'
    },
    {
      title: 'Tolerancia',
      description: 'Reconocer las diferencias como parte de la riqueza de cada ser humano.',
      icon: '🤝'
    },
    {
      title: 'Respeto',
      description: 'Aceptar y valorar a los demás.',
      icon: '🙏'
    },
    {
      title: 'Colaboración',
      description: 'Compromiso con un resultado común a través de aportar poder y recibir ayuda.',
      icon: '👥'
    },
    {
      title: 'Resiliencia',
      description: 'Tenacidad para resolver a pesar de las dificultades.',
      icon: '💪'
    }
  ]

  return (
    <article className="min-h-screen">
      {/* Hero Section */}
      <Hero 
        title="Nuestra misión, visión, valores y nuestra historia"
        subtitle="Conoce más sobre La Gaviota"
        backgroundImage="/images/banners/patio_gaviota.jpg"
      />
      
      {/* Main Content */}
      <div className="max-w-[1280px] mx-auto px-8 py-16">
        {/* Mission Section */}
        <section className="mb-16">
          <h2 className="headline-large mb-4">Misión</h2>
          <div className="p-6 border border-gray-200 rounded-lg">
            <p className="body-medium text-gray-700">
              Apoyamos a los niños con y sin discapacidad y a su entorno familiar para desarrollarles capacidades y 
              habilidades motrices, cognitivas, afectivas y de comunicación para valerse por sí mismos y ayudar a otros.
            </p>
          </div>
        </section>

        {/* Vision Section */}
        <section className="mb-16">
          <h2 className="headline-large mb-4">Visión</h2>
          <div className="p-6 border border-gray-200 rounded-lg">
            <p className="body-medium text-gray-700">
              Nuestros egresados se valoran a sí mismos y a los demás contribuyendo al mundo común.
            </p>
          </div>
        </section>

        {/* Decorative Banner */}
        <div
          className="w-screen h-[75vh] mb-16 overflow-hidden"
          style={{
            width: '100vw',
            marginLeft: 'calc(-50vw + 50%)',
            backgroundImage: 'url("/images/banners/bath_gaviota.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
          role="img"
          aria-label="Decorative Banner"
        />

        {/* Map Section */}
        <section className="mb-40">
          <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] h-[400px] mb-32 overflow-hidden">
            <Map />
          </div>
        </section>

        {/* Values Section */}
        <section className="pt-40 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 justify-between min-h-[800px]">
            {/* Left Column - Sticky */}
            <div className="self-start lg:sticky lg:top-32 max-w-sm">
              <h2 className="headline-large">Valores</h2>
              <p className="body text-gray-600 mt-4">
                Los valores que nos definen y guían nuestro trabajo día a día.
              </p>
            </div>

            {/* Values List */}
            <div className="space-y-16 max-w-xl ml-auto">
              {values.map(value => (
                <div key={value.title} className="flex items-start space-x-6">
                  <div className="text-5xl text-blue-600 flex-shrink-0">{value.icon}</div>
                  <div>
                    <h3 className="headline-medium mb-2">{value.title}</h3>
                    <p className="body text-gray-600">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* Logo Ticker - Full width */}
      <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] overflow-hidden">
        <LogoTicker />
      </div>

      {/* History Timeline */}
      <div className="max-w-[1280px] mx-auto px-8">
        <section className="mt-32 mb-32">
          <h2 className="headline-large mb-16">Historia</h2>

          {/* 1953 */}
          <div className="mb-16">
            <h3 className="headline-medium mb-4">1953</h3>
            <p className="body text-gray-700">
              Inauguración del Comité de Damas de Nuestra Señora del Socorro, junto con la Secretaría de Salubridad y 
              Asistencia, inauguró una guardería infantil atendida por religiosas para niños de la zona.
            </p>
          </div>

          {/* 1986 */}
          <div className="mb-16">
            <h3 className="headline-medium mb-4">1986</h3>
            <p className="body text-gray-700">
              Se dona la propiedad a APAC (Asociación Pro-Personas con Parálisis Cerebral) y se comenzó a brindar el 
              servicio de terapia a niños con discapacidad neuromotora
            </p>
          </div>

          {/* 1996 */}
          <div className="mb-16">
            <h3 className="headline-medium mb-4">1996</h3>
            <p className="body text-gray-700">
              APAC cede sus instalaciones y su población a un nuevo patronato y se constituye el Centro de Estimulación 
              Temprana la Gaviota
            </p>
          </div>

          {/* En la Actualidad */}
          <div>
            <h3 className="headline-medium mb-4 text-orange-500">En la Actualidad</h3>
            <p className="body text-gray-700 mb-8">
              Gaviota está incorporada a la SEP, quienes autorizan y dan el reconocimiento de validez oficial de estudios 
              con modalidad escolarizada Clave de Centro de Trabajo (CCT) 09PML0012G y acuerdo de incorporación 
              PREE-09160023CT, efectuado el 6 de Mayo de 2016 — En el inmueble ubicado en SUR 136#24 Col. América Alcaldía Miguel Hidalgo c.p. 
              11820 Ciudad de México
            </p>
            <p className="body text-gray-700">
              Ahora, brindamos servicios a 60 niños con discapacidad y desarrollo regular de forma anual de 1 a 10 años 
              de edad, a través de una educación preescolar integral e inclusiva.
            </p>
          </div>
        </section>
      </div>
    </article>
  )
} 